import jwt_decode from "jwt-decode";
import http from "src/_services/httpService";
import { $BASE_URL, ROLES } from "src/constants";
import { pick } from "lodash";
import store from "src/_store/store";
import { setUserProfile } from "src/_store/entities/profile";
import { setCustomizationsState } from "src/_store/entities/customizations";
import { apiSlice } from "src/_api/apiSlice";

var CryptoJS = require("crypto-js");

const apiUrl = $BASE_URL + "/api";

const apiEndpoints = {
  [ROLES.admin]: apiUrl + "/v1/admin-panel/login",
  [ROLES.merchant]: apiUrl + "/v1/merchant-dashboard/login",
  [ROLES.shippingCompany]: apiUrl + "/v1/merchant-dashboard/login",
  merchant: apiUrl + "/v1/merchant-dashboard/login",
  [ROLES.warehouseGuard]: apiUrl + "/v1/warehouse_guard/login",
  driver: apiUrl + "/v1/driver/login",
};

const tokenKey = "token";
const currentUserKey = "current_user";

export async function login(role, credentials) {
  const response = await http.post(apiEndpoints[role], { ...credentials });
  return response.data.body;
}

export async function registerAsMerchant(credentials) {
  const response = await http.post(apiUrl + "/v1/merchant-dashboard/register", {
    ...credentials,
  });
  return response.data.body;
}
export async function registerAsFreelanceDriver(credentials) {
  const response = await http.post(apiUrl + "/v1/driver/register", {
    ...credentials,
  });
  return response.data.body;
}

export async function sendEmailToResetPassword(email, type) {
  const response = await http.post(
    `${apiUrl}/v1/${
      type === "GENERAL" ? "user" : "merchant-dashboard"
    }/forget-password`,
    { email }
  );
  return response;
}

export async function resetPassword(credentials, type) {
  const response = await http.put(
    `${apiUrl}/v1/${
      type === "GENERAL" ? "user" : "merchant-dashboard"
    }/reset-forgotten-password`,
    { ...credentials }
  );
  return response;
}

export async function verifyEmail(token) {
  const response = await http.post(
    apiUrl + "/v1/merchant-dashboard/verify-mail",
    { token }
  );
  return response;
}

export async function verifyPhone(params) {
  const response = await http.post(
    apiUrl + "/v1/merchant-dashboard/verify-phone",
    params
  );
  return response;
}

export async function changeMerchantRegistrationPhone(params) {
  //const cryptr = new CryptoJS('mapIt@0000');
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(params),
    "mapIt@0000"
  ).toString();
  const response = await http.put(
    apiUrl + "/v1/merchant-dashboard/update-phone",
    { encryptedData }
  );
  return response;
}

export function loginWithJwt(jwt, user) {
  localStorage.setItem(tokenKey, jwt);
  const decodedJWT = jwt_decode(jwt);
  const currentUser = pick(decodedJWT, [
    "companyName",
    "email",
    "id",
    "logo",
    "role",
    "priceType",
  ]);
  if (!!user?.logo) {
    currentUser.logo = user.logo;
  }
  localStorage.setItem(currentUserKey, JSON.stringify(currentUser));

  http.setJwt(jwt);
}

export function logout() {
  store.dispatch(setUserProfile(null));
  store.dispatch(
    setCustomizationsState({
      warehouse: "",
    })
  );
  // Drop every RTK Query cache so the next user never sees this one's data
  store.dispatch(apiSlice.util.resetApiState());
  const keysToKeep = ["isFirstTourCompleted"];

  Object.keys(localStorage).forEach((key) => {
    // console.log(localStorage);

    if (!keysToKeep.includes(key)) {
      localStorage.removeItem(key);
    }
  });
}

export function getCurrentUser() {
  try {
    const stringifiedUser = localStorage.getItem(currentUserKey);
    const user = JSON.parse(stringifiedUser);
    return user;
  } catch (ex) {
    return null;
  }
}

export function setCurrentUser(user) {
  try {
    const stringifiedUser = localStorage.getItem(currentUserKey);
    const oldUser = JSON.parse(stringifiedUser);
    const newUser = {
      ...oldUser,
      companyName: user.companyName,
      email: user.email,
      logo: user.logo,
    };
    localStorage.setItem(currentUserKey, JSON.stringify(newUser));
  } catch (ex) {
    return null;
  }
}

const isJwtValid = (token) => {
  const { exp } = jwt_decode(token);
  const expDate = new Date(parseInt(exp) * 1000);
  const nowDate = new Date();
  return nowDate < expDate;
};

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export async function getCurrentUserProfile() {
  const response = await http.get(apiUrl + "/v1/auth/me");
  return response;
}

async function updateProfile(payload) {
  const response = await http.put(apiUrl + "/v1/merchant-dashboard/profile", {
    ...payload,
  });
  return response.data.body;
}

http.setJwt(getJwt());

const AuthService = {
  login,
  registerAsMerchant,
  registerAsFreelanceDriver,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
  isJwtValid,
  sendEmailToResetPassword,
  verifyEmail,
  verifyPhone,
  resetPassword,
  changeMerchantRegistrationPhone,
  setCurrentUser,
  getCurrentUserProfile,
  updateProfile,
};

export default AuthService;
